import { createAction } from 'redux-actions';


export const addServiceToShortlist = createAction('LOCAL_SHORTLIST:SERVICES:ADD', ({serviceId}) => ({serviceId}));


export const removeServiceFromShortlist = createAction('LOCAL_SHORTLIST:SERVICES:REMOVE', ({serviceId}) => ({serviceId}));


// WEBPACK FOOTER //
// ./src/actions/localShortlist.js